import type { Locale } from "./types";

export type LoginHandoffLink = {
  id: "dynamicbooks_login";
  href: Record<Locale, string>;
  label: Record<Locale, string>;
  body: Record<Locale, string>;
};

export type LoginHandoffContent = {
  eyebrow: string;
  title: string;
  lead: string;
  boundary: string;
  links: LoginHandoffLink[];
};

export const dynamicBooksLoginStartUrls: Record<Locale, string> = {
  sv: "/auth/saml/start?return_to=%2Fmail%2Finbox&locale=sv",
  en: "/auth/saml/start?return_to=%2Fmail%2Finbox&locale=en"
};

export const loginHandoffContent: Record<Locale, LoginHandoffContent> = {
  sv: {
    eyebrow: "Inloggning",
    title: "Logga in i DynamicBooks",
    lead: "Fortsätt säkert med BankID eller Google och landa direkt i din DynamicMail-arbetsyta.",
    boundary: "Bolagsvalet sker innan inkorgen öppnas, så DynamicBooks startar i rätt bolagsyta.",
    links: [
      {
        id: "dynamicbooks_login",
        href: dynamicBooksLoginStartUrls,
        label: {
          sv: "Logga in",
          en: "Log in"
        },
        body: {
          sv: "För befintliga kunder som vill öppna bokföringsytan i DynamicMail.",
          en: "For existing customers who want to open the accounting workspace in DynamicMail."
        }
      }
    ]
  },
  en: {
    eyebrow: "Login",
    title: "Log in to DynamicBooks",
    lead: "Continue securely with BankID or Google and land directly in your DynamicMail workspace.",
    boundary: "Company selection happens before the inbox opens, so DynamicBooks starts in the right tenant.",
    links: [
      {
        id: "dynamicbooks_login",
        href: dynamicBooksLoginStartUrls,
        label: {
          sv: "Logga in",
          en: "Log in"
        },
        body: {
          sv: "För befintliga kunder som vill öppna bokföringsytan i DynamicMail.",
          en: "For existing customers who want to open the accounting workspace in DynamicMail."
        }
      }
    ]
  }
};
